import React from "react";
import { NavLink } from "react-router-dom";

export default function AIWebsiteDesignWithSEO() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">AI-Enabled Website Designing with SEO</h1>
            <h5 className="text-muted">
              Smarter, Faster, and Search-Optimized Websites That Rank and Convert
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/seo-analytics-concept-illustration_114360-8593.jpg"
              alt="AI Website SEO"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Choose AI-Enhanced Website Design?</h2>
            <p>
              <strong>Bytlas Intelligence</strong> crafts websites that don’t just look good — they perform.
              Our AI-driven platforms analyze user behavior, automate SEO practices, and adapt content 
              to improve your visibility across search engines like Google and Bing.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ AI-Generated Layout and UI Suggestions</li>
              <li className="list-group-item">✅ Automatic Meta Tag & Keyword Optimization</li>
              <li className="list-group-item">✅ PageSpeed & Mobile Optimization</li>
              <li className="list-group-item">✅ Real-time SEO Score Suggestions</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">SEO That Works — Powered by AI</h3>
            <p>
              Our intelligent design tools ensure your website is SEO-friendly from the ground up. 
              From on-page optimizations like structured data and sitemaps to live keyword tracking 
              and content recommendations, we cover it all.
            </p>
            <p>
              You get full visibility of how your content performs and where it ranks—without 
              the need for third-party tools.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">What You Get</h3>
            <ul>
              <li>🧠 AI-Driven SEO Reports</li>
              <li>📱 Mobile-First Responsive Design</li>
              <li>🌐 Google Analytics & Search Console Integration</li>
              <li>📝 On-Page Content and Schema Optimization</li>
              <li>💡 UX Heatmaps and Behavior Tracking</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Book a Free Website Audit
          </NavLink>
        </div>
      </div>
    </section>
  );
}
